/**
 * FeaturedCardCarousel.js
 */

import $ from 'jquery';
import Flickity from 'flickity-fade';

export default class FeaturedCardCarousel {

    constructor() {

        this.$slideshow = $('.featured-card-carousel');
    
        this.enableFlickity();

    }

    enableFlickity() {

        if (!this.$slideshow.length) {
            return;
        }

        this.$slideshow.each((_, element) => {
            const $element = $(element);
            let flickity = null;
            const adjustDots = (index)=> {
              $dots.addClass('bg-light-gray').removeClass('bg-orange');
              flickity.select(index);
              const $selectedDot = $($dots[index]);
              $selectedDot.removeClass('bg-light-gray').addClass('bg-orange')
            }

            const $dots =  $element.siblings('.absolute').find('li');
            $dots.each((_, dot)=> {
                const $dot = $(dot);
                $dot.on('click', () => {
                    adjustDots($dot.index())
                });
            })

            flickity = new Flickity(element, {
                autoPlay: false,
                cellAlign: 'left',
                contain: true,
                imagesLoaded: true,
                pageDots: false,
                wrapAround: true,
                prevNextButtons: true,
                arrowShape: `M1.5,46.3c-2,2-2,5.3,0,7.3l42.2,42.2c2,2,5.3,2,7.3,0c2-2,2-5.3,0-7.3l-34-34h77.8c2.9,0,5.2-2.3,5.2-5.2
                c0-2.9-2.3-5.2-5.2-5.2H18.4l32.7-32.7c2-2,2-5.3,0-7.3c-2-2-5.3-2-7.3,0L1.5,46.3z`,
                ...$element.data('flickity'),
                on: {
                    change: (index)=> {
                        adjustDots(index)
                        if(window.currentVimeoPlayer) {
                           window.currentVimeoPlayer.pause();
                        }
                    }
                }
            });

      })   
  }
}
